module.exports = __webpack_public_path__ + "media/images/icons/search-1262a1edbab3aef14c9a59bfdd84ae3f.svg";